export default {
  background_image: 'Obraz tła',
};
